import React, { useState } from 'react';
import { products } from '../data/storeData';
import ProductCard from './ProductCard';
import { motion, AnimatePresence } from 'framer-motion';

const devices = ['All', 'iPhone 15 Pro', 'S24 Ultra', 'Pixel 8 Pro', 'Universal'];

const ProductSection = () => {
  const [activeFilter, setActiveFilter] = useState('All');

  const filteredProducts = activeFilter === 'All' 
    ? products 
    : products.filter(p => p.device === activeFilter);

  return (
    <section id="drop" className="py-32 px-6 max-w-7xl mx-auto">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12 mb-20">
        <div className="max-w-xl">
          <h2 className="text-5xl sm:text-7xl font-black uppercase tracking-tighter leading-[0.9] mb-6">
            Current <br />
            <span className="text-zinc-600">Inventory</span>
          </h2>
          <div className="h-1 w-20 bg-cyan-400 mb-6" />
          <p className="text-zinc-400 text-sm leading-relaxed">
            Every piece is precision-machined and hand-inspected for the Drop 001 collection. Filter by your hardware platform below.
          </p>
        </div>
        
        <div className="flex flex-wrap gap-2 lg:mb-2">
          {devices.map(device => (
            <button
              key={device}
              onClick={() => setActiveFilter(device)}
              className={`px-5 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest border transition-all duration-300
                ${activeFilter === device 
                  ? 'bg-white text-black border-white shadow-[0_0_20px_rgba(255,255,255,0.2)]' 
                  : 'bg-transparent text-zinc-500 border-white/10 hover:border-white/30'}`}
            >
              {device}
            </button>
          ))}
        </div>
      </div>

      <div className="stagger-grid">
        <AnimatePresence mode="popLayout">
          {filteredProducts.map((product, index) => (
            <ProductCard key={product.id} product={product} index={index} />
          ))}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default ProductSection;